import { render, staticRenderFns } from "./MFData.vue?vue&type=template&id=1a6ea4b1"
import script from "./MFData.vue?vue&type=script&lang=js"
export * from "./MFData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports